'use client'
import { createContext, useContext } from 'react'

import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_CONFIG } from '@src/config/statsig-experiments.config'

export interface StatsigInitContextType {
  init: boolean
  getExperimentBucket: (experimentName: STATSIG_EXPERIMENTS | null) => string | null
}

export const StatsigInitContext = createContext<StatsigInitContextType>({
  init: false,
  getExperimentBucket(_experimentName: STATSIG_EXPERIMENTS | null) {
    if (!_experimentName) return null
    return STATSIG_EXPERIMENTS_CONFIG[_experimentName].defaultBucket
  },
})

export function useStatsigInitContext() {
  return useContext(StatsigInitContext)
}
